import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {ButtonPriority, Text} from 'wix-ui-tpa';
import {classes} from './Footer.st.css';
import {CheckoutButton} from '../../../../../common/components/CheckoutButton/CheckoutButton';
import {CartButton} from '../CartButton/CartButton';
import {SecureCheckout} from '../../../../../common/components/SecureCheckout/SecureCheckout';
import {Violations} from '../../../../../common/components/Violations/Violations';
import settingsParams from '../../../settingsParams';
import {useSettings} from '@wix/tpa-settings/react';

export enum FooterDataHooks {
  root = 'Footer.root',
  totalLabel = 'Footer.totalLabel',
  totalValue = 'Footer.totalValue',
  totalDisclaimer = 'Footer.totalDisclaimer',
}

export const Footer = () => {
  const {t} = useTranslation();
  const {cart, shouldRenderEmptyState} = useControllerProps().cartStore;
  const {isCheckoutButtonDisabled} = useControllerProps().navigationStore;
  const {get: getSettings} = useSettings();
  if (shouldRenderEmptyState) {
    return false;
  }

  return (
    <div className={classes.root} data-hook={FooterDataHooks.root}>
      <dl className={classes.totalRow}>
        <Text tagName={'dt'} data-hook={FooterDataHooks.totalLabel} className={classes.totalLabel}>
          {t('sideCart.subtotal.label')}
        </Text>

        <Text tagName={'dd'} data-hook={FooterDataHooks.totalValue} className={classes.totalValue}>
          {cart.convertedTotals.formattedTotal}
        </Text>
      </dl>
      <div className={classes.disclaimer}>
        <Text data-hook={FooterDataHooks.totalDisclaimer} className={classes.disclaimerText}>
          {t('sideCart.subtotal.disclaimer')}
        </Text>
      </div>
      <Violations />
      <div className={classes.buttons}>
        <CheckoutButton
          priority={ButtonPriority.primary}
          disabled={isCheckoutButtonDisabled}
          text={getSettings(settingsParams.CART_BUTTON_TEXT) as string}
        />
        <CartButton />
      </div>
      <SecureCheckout text={t('sideCart.secureCheckout.badge')} />
    </div>
  );
};
